import { view } from '@yola/ws-sdk';

const getWsNav = () => {
  const liveDocument = view.accessors.getLiveDocument();
  const headerComponent = liveDocument.querySelector('ws-header');

  if (headerComponent?.isDynamicMode) {
    return headerComponent.shadowRoot.querySelector('ws-nav');
  }

  return liveDocument.querySelector('ws-nav');
};

export default getWsNav;
